<div class="maintenance-bg"></div>
<div class="login-grid-bg"></div>
<div class="maintenance-center-container">
  <div class="maintenance-card-modern">
    <div class="maintenance-icon-minimal">
      <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M33.5 29.5L20.5 16.5C22.5 12.5 21.5 7.5 17.5 4.5C14.1 1.9 9.3 1.9 5.9 4.5L13.5 12.1L12.1 13.5L4.5 5.9C1.9 9.3 1.9 14.1 4.5 17.5C7.5 21.5 12.5 22.5 16.5 20.5L29.5 33.5C30.1 34.1 31.1 34.1 31.7 33.5L33.5 31.7C34.1 31.1 34.1 30.1 33.5 29.5Z" fill="#6366f1"/>
      </svg>
    </div>
    <h2 class="maintenance-card-title">Scheduled Maintenance</h2>
    <div class="maintenance-card-message">
      <ng-container *ngIf="maintenanceMessage; else defaultMsg">
        <span class="maintenance-message-highlight">{{ maintenanceMessage }}</span>
      </ng-container>
      <ng-template #defaultMsg>
        <span class="maintenance-message-default">
          Our platform is currently undergoing scheduled maintenance to improve your experience.<br>
          <span class="maintenance-highlight">We'll be back soon!</span>
        </span>
      </ng-template>
    </div>
    <div class="maintenance-status-indicator">
      <span class="status-dot"></span>
      <span class="status-text">Maintenance in Progress</span>
    </div>
    <div class="brand">Team NeoPAT</div>
  </div>
</div>